import { DeepPartial, ESTENSA_MODULE_RADIO_SETTINGS_SERVICE } from '@se/platform';
import { ObscuredTabType, RadioSettings } from 'estensa-module';

export class NullRadioSettingsService {
    getAsJSON(): Promise<DeepPartial<RadioSettings>> {
        // Questi sono i radio setting essenziali per far partire la standalone.
        return Promise.resolve({
            collaborationSettings: {
                isEnabled: false,
            },
            completeCdWorklistSettings: {
                searchTypeDefs: '[]',
                searchParamDefs: '[]',
            },
            ecgSettings: {
                enableAlerts: false,
            },
            ecgWorklistSettings: {
                searchTypeDefs: '[]',
                searchParamDefs: '[]',
            },
            executionWorklistSettings: {
                searchParamDefs: '[]',
                searchTypeDefs: '[]',
            },
            extensaSettings: {
                webApiPort: '9999',
            },
            healthPlatformSettings: {
                remoteVisitDescription: '',
                urlHttpAutoLogin: '',
            },
            onPrintingCdWorklistSettings: {
                searchTypeDefs: '[]',
                searchParamDefs: '[]',
            },
            reportConfiguration: {
                obscuredTabType: ObscuredTabType.None,
            },
            reportSettings: {
                signType: -1,
            },
            visitWorklistSettings: {
                searchParamDefs: '[]',
                searchTypeDefs: '[]',
            },
            viewerSettings: {
                webViewerType: 'eUnity',
            },
            specialtyWorklistSettings: {
                searchTypeDefs: '[]',
                searchParamDefs: '[]',
            }
        });
    }

    isExternalSigningEnabled() {
        return false;
    }
}

export function provideMockRadioSettingsService() {
    return {
        provide: ESTENSA_MODULE_RADIO_SETTINGS_SERVICE,
        useClass: NullRadioSettingsService,
    };
}
